import { t } from '../../i18n-t';
import type { FormConfig } from '../types';

export const getThirdPartyFormConfig = () => {
  return {
    title: {
      fieldId: 'title',
      formLabel: t('third_party.fields.title'),
      columnHeader: t('third_party.columns.title'),
      allowAsConditionSource: true,
    },
    description: {
      fieldId: 'description',
      formLabel: t('third_party.fields.description'),
      columnHeader: t('third_party.columns.description'),
      allowTargetConditions: true,
      displayType: { displayType: 'textarea' },
    },
    companyName: {
      fieldId: 'companyName',
      formLabel: t('third_party.fields.companyName'),
      columnHeader: t('third_party.columns.companyName'),
      allowAsConditionSource: true,
      allowTargetConditions: true,
    },
    companiesHouseNumber: {
      fieldId: 'companiesHouseNumber',
      formLabel: t('third_party.fields.companiesHouseNumber'),
      columnHeader: t('third_party.columns.companiesHouseNumber'),
      allowAsConditionSource: true,
      allowTargetConditions: true,
    },
    address: {
      fieldId: 'address',
      formLabel: t('third_party.fields.address'),
      columnHeader: t('third_party.columns.address'),
      allowAsConditionSource: true,
      allowTargetConditions: true,
    },
    cityTown: {
      fieldId: 'cityTown',
      formLabel: t('third_party.fields.cityTown'),
      columnHeader: t('third_party.columns.cityTown'),
      allowAsConditionSource: true,
      allowTargetConditions: true,
    },
    postcode: {
      fieldId: 'postcode',
      formLabel: t('third_party.fields.postcode'),
      columnHeader: t('third_party.columns.postcode'),
      allowAsConditionSource: true,
      allowTargetConditions: true,
    },
    country: {
      fieldId: 'country',
      formLabel: t('third_party.fields.country'),
      columnHeader: t('third_party.columns.country'),
      allowAsConditionSource: true,
      allowTargetConditions: true,
    },
    primaryContactName: {
      fieldId: 'primaryContactName',
      formLabel: t('third_party.fields.primaryContactName'),
      columnHeader: t('third_party.columns.primaryContactName'),
      allowAsConditionSource: true,
      allowTargetConditions: true,
    },
    contactName: {
      fieldId: 'contactName',
      formLabel: t('third_party.fields.contactName'),
      columnHeader: t('third_party.columns.contactName'),
      allowAsConditionSource: true,
      allowTargetConditions: true,
    },
    contactEmail: {
      fieldId: 'contactEmail',
      formLabel: t('third_party.fields.contactEmail'),
      columnHeader: t('third_party.columns.contactEmail'),
      allowAsConditionSource: true,
      allowTargetConditions: true,
    },
    companyDomain: {
      fieldId: 'companyDomain',
      formLabel: t('third_party.fields.companyDomain'),
      columnHeader: t('third_party.columns.companyDomain'),
      allowAsConditionSource: true,
      allowTargetConditions: true,
    },
    type: {
      fieldId: 'type',
      formLabel: t('third_party.fields.type'),
      columnHeader: t('columns.type'),
      displayType: { displayType: 'rating', ratingKey: 'third_party_type' },
      allowAsConditionSource: true,
    },
    status: {
      fieldId: 'status',
      formLabel: t('third_party.fields.status'),
      columnHeader: t('columns.status'),
      allowAsConditionSource: true,
      displayType: { displayType: 'rating', ratingKey: 'third_party_status' },
    },
    criticality: {
      fieldId: 'criticality',
      formLabel: t('third_party.fields.criticality'),
      columnHeader: t('third_party.columns.criticality'),
      displayType: {
        displayType: 'rating',
        ratingKey: 'third_party_criticality',
      },
      allowAsConditionSource: true,
      allowTargetConditions: true,
    },
    Owners: {
      fieldId: 'Owners',
      formLabel: t('fields.Owner'),
      columnHeader: t('columns.owners'),
      displayType: {
        displayType: 'users',
        multiple: true,
      },
      allowAsConditionSource: true,
    },
    Contributors: {
      fieldId: 'Contributors',
      formLabel: t('fields.Contributor'),
      columnHeader: t('columns.contributors'),
      displayType: {
        displayType: 'users',
        multiple: true,
      },
      allowAsConditionSource: true,
      allowTargetConditions: true,
    },
    Viewers: {
      fieldId: 'Viewers',
      formLabel: t(`fields.Viewer`),
      columnHeader: t(`columns.viewers`),
      displayType: {
        displayType: 'users',
        multiple: true,
      },
      allowAsConditionSource: true,
      allowTargetConditions: true,
    },
    tags: {
      fieldId: 'tags',
      formLabel: t('fields.Tags'),
      columnHeader: t('columns.tags'),
      displayType: {
        displayType: 'tags',
      },
      allowAsConditionSource: true,
      allowTargetConditions: true,
    },
    departments: {
      fieldId: 'departments',
      formLabel: t('fields.Departments'),
      columnHeader: t('columns.departments'),
      displayType: {
        displayType: 'departments',
      },
      allowAsConditionSource: true,
      allowTargetConditions: true,
    },
    files: {
      fieldId: 'files',
      formLabel: t('third_party.fields.newFiles'),
      allowTargetConditions: true,
    },
  } as const satisfies FormConfig;
};
